import { render, staticRenderFns } from "./MsgDialog.vue?vue&type=template&id=0f699152"
import script from "./MsgDialog.vue?vue&type=script&lang=js"
export * from "./MsgDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports